module.exports = __webpack_public_path__ + "img/327.35be4132.png";